import React from 'react';
import { QuoteIcon, StarIcon, StarHalfIcon, MicIcon } from 'lucide-react';
export function TestimonialsSection() {
  const textTestimonials = [{
    name: 'Ricardo M.',
    location: 'Ciudad de México',
    result: 'Antes invisible → Ahora líder de grupo',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
    stars: 4,
    halfStar: false,
    quote: 'Siempre era el que se quedaba en la esquina de la fiesta esperando que alguien le hablara. Apliqué el truco de la "Mirada Triangular" y el de "Posición de Poder" que viene en el manual y el cambio en cómo me perciben las personas es impresionante. Ya no me ignoran, ahora ellas inician la conversación.'
  }, {
    name: 'Javier L.',
    location: 'Monterrey',
    result: 'Salió del estancamiento social',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face',
    stars: 4,
    halfStar: false,
    quote: 'Estaba cansado de que me dejaran en visto o que me trataran como el "mejor amigo". Estos trucos no son para impresionar por impresionar, es para que tu energía cambie. Me ayudó mucho a entender qué estaba haciendo mal en mis interacciones. ¡Súper recomendado si quieres dejar de ser invisible!'
  }];
  const renderStars = (filled: number, hasHalf: boolean = false) => {
    const stars = [];
    for (let i = 0; i < filled; i++) {
      stars.push(<StarIcon key={`filled-${i}`} className="w-5 h-5 fill-gold text-gold" data-id="element-224" />);
    }
    if (hasHalf) {
      stars.push(<StarHalfIcon key="half" className="w-5 h-5 fill-gold text-gold" data-id="element-225" />);
    }
    const empty = 5 - filled - (hasHalf ? 1 : 0);
    for (let i = 0; i < empty; i++) {
      stars.push(<StarIcon key={`empty-${i}`} className="w-5 h-5 text-gray-600" data-id="element-226" />);
    }
    return stars;
  };
  return <section id="testimonials-section" className="py-12 bg-surface-primary border-y border-surface-border" data-id="element-227">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <div className="text-center mb-10" data-id="element-229">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-230">
            Resultados <span className="text-gold" data-id="element-231">Reales</span>
          </h2>
          <p className="font-body text-gray-400 text-lg" data-id="element-232">
            Hombres que ya dominan las dinámicas de atracción social.
          </p>
        </div>

        {/* Featured Audio Testimonial */}
        <div className="mb-12 bg-surface-card rounded-3xl border border-gold/30 overflow-hidden shadow-2xl shadow-gold/5 max-w-3xl mx-auto p-8 relative" data-id="element-233">
          <QuoteIcon className="absolute top-8 right-8 w-20 h-20 text-surface-elevated opacity-50" data-id="element-234" />

          <div className="flex items-center space-x-1 mb-6" data-id="element-235">
            {renderStars(5)}
          </div>

          <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4 relative z-10" data-id="element-236">
            "Toda mi vida fui el tipo callado..."
          </h3>

          <p className="font-body text-gray-300 text-lg italic mb-8 relative z-10 leading-relaxed" data-id="element-237">
            Escucha la historia de Carlos, quien pasó de sudar las manos al
            hablar con mujeres, a dominar el carisma al instante y transformar
            por completo su vida social.
          </p>

          <div className="bg-surface-elevated rounded-2xl p-5 md:p-6 flex flex-col sm:flex-row items-center gap-6 border border-surface-border relative z-10" data-id="element-238">
            <div className="relative flex-shrink-0" data-id="element-239">
              <img src="https://images.unsplash.com/photo-1583864697784-a0efc8379f70?w=150&h=150&fit=crop&crop=face" alt="Carlos" className="w-24 h-24 rounded-full object-cover border-2 border-gold/50 shadow-lg" data-id="element-240" />
              <div className="absolute -bottom-2 -right-2 bg-gold text-surface-deepest p-2 rounded-full shadow-lg" data-id="element-241">
                <MicIcon className="w-4 h-4" data-id="element-242" />
              </div>
            </div>

            <div className="flex-1 w-full" data-id="element-243">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-2" data-id="element-244">
                <div data-id="element-245">
                  <h4 className="font-heading font-bold text-white text-xl" data-id="element-246">
                    Carlos (32 años)
                  </h4>
                  <p className="font-body text-sm text-gold-light" data-id="element-247">
                    Guadalajara • Transformación Total
                  </p>
                </div>
                <span className="text-xs font-bold text-gold-light bg-gold/10 px-3 py-1.5 rounded-full border border-gold/20 inline-block text-center" data-id="element-248">
                  Nota de voz
                </span>
              </div>

              {/* Audio Player */}
              <audio controls className="w-full h-12 outline-none rounded-lg" data-id="element-249">
                <source src="https://cdn.magicpatterns.com/uploads/vcESpeYqGeNirZ2WjPm6wa/testimonio%20carlos%20.mp4" type="audio/mp4" data-id="element-250" />
                Tu navegador no soporta el elemento de audio.
              </audio>
            </div>
          </div>
        </div>

        {/* Text Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-251">
          {textTestimonials.map((t, index) => <div key={index} className="bg-surface-card p-8 rounded-2xl border border-surface-border relative hover:border-gold/20 transition-colors" data-id="element-252">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-surface-elevated" data-id="element-253" />

              <div className="flex items-center space-x-1 mb-6" data-id="element-254">
                {renderStars(t.stars, t.halfStar)}
              </div>

              <p className="font-body text-gray-300 text-lg italic mb-8 relative z-10 leading-relaxed" data-id="element-255">
                "{t.quote}"
              </p>

              <div className="flex items-center border-t border-surface-border pt-6" data-id="element-256">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-gold/30 mr-4" data-id="element-257" />
                <div data-id="element-258">
                  <h4 className="font-heading font-bold text-white text-lg" data-id="element-259">
                    {t.name}
                  </h4>
                  <p className="font-body text-sm text-gold-light" data-id="element-260">
                    {t.location} • {t.result}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}